export const FETCH_YODLEE_CONSENT = 'YODLEE_CONSENT';
export const FETCH_YODLEE_CONSENT_SUCCESS = 'YODLEE_CONSENT_SUCCESS';
export const FETCH_YODLEE_CONSENT_ERROR = 'YODLEE_CONSENT_ERROR';
export const YODLEE_REFRESH = 'YODLEE_REFRESH';
export const YODLEE_REFRESH_SUCCESS = 'YODLEE_REFRESH_SUCCESS';
export const YODLEE_REFRESH_ERROR = 'YODLEE_REFRESH_ERROR';

export const fetchYodleeConsent = () => ({ type: FETCH_YODLEE_CONSENT });
export const fetchYodleeConsentSuccess = (payload: any) => ({ type: FETCH_YODLEE_CONSENT_SUCCESS, payload });
export const fetchYodleeConsentError = (payload: any) => ({ type: FETCH_YODLEE_CONSENT_ERROR, payload });

export const yodleeRefresh = () => ({ type: YODLEE_REFRESH });
export const yodleeRefreshSuccess = (payload: any) => ({ type: YODLEE_REFRESH_SUCCESS, payload });
export const yodleeRefreshError = (payload: any) => ({ type: YODLEE_REFRESH_ERROR, payload });
